import {
  Box,
  Flex,
  Image,
  Text,
  em,
  Menu,
  rem,
  Group,
  Modal,
  Select,
  Button,
  Avatar,
  Burger,
} from '@mantine/core';
import React, { useState, useEffect } from 'react';
import Logo from '../assets/img/Logo_Consili18.svg';
import { IconSettings, IconLogout2 } from '@tabler/icons-react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import {
  useLazyLogoutQuery,
  useUpdateUserSettingsMutation,
  useUserSettingsQuery,
  useConstantsQuery,
} from '../endpoints/user';
import { baseApi } from '../endpoints/createApi';
import { IconCheck } from '@tabler/icons-react';

const Header = ({ user, mobileOpened, toggleMobile }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [getLogout] = useLazyLogoutQuery();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [value, setValue] = useState('All insights');
  const [analysisNotifications, setAnalysisNotifications] = useState([]);
  const [updateUserSettings] = useUpdateUserSettingsMutation();
  const { data: constantsData, isLoading: isConstantsLoading } =
    useConstantsQuery();
  const { data: settingsData, isLoading: isSettingsLoading } =
    useUserSettingsQuery();
  const handleSignOut = () => {
    getLogout();
    dispatch(baseApi.util.resetApiState());
    navigate('/login');
    window.scrollTo(0, 0);
  };
  const data = user?.data;
  const regexPattern = /([a-zA-Z]).*?([a-zA-Z])/;

  useEffect(() => {
    setValue(
      constantsData?.analysis_notify_type[
        settingsData?.analysis_notifications
      ] || 'All insights'
    );
  }, [settingsData, isSettingsLoading, constantsData, isConstantsLoading]);

  useEffect(() => {
    setAnalysisNotifications(
      Object.values(constantsData?.analysis_notify_type ?? {})
    );
  }, [constantsData, isConstantsLoading]);

  const updateSettings = () => {
    updateUserSettings({
      ...user.data[0],
      analysis_notifications:
        Object.keys(constantsData?.analysis_notify_type ?? {}).find(
          (key) => constantsData?.analysis_notify_type[key] === value
        ) || 'A',
    });
  };

  const getUsername = () => {
    if (user.isSuccess) {
      if (user.data?.[0]?.first_name && user.data?.[0]?.last_name) {
        const firstName = data?.[0]?.first_name;
        const lastName = data?.[0]?.last_name;
        const username = `${firstName} ${lastName}`;
        return username;
      } else return user.data?.[0].username;
    }
    return 'Unknown User';
  };

  const firstName = data?.[0]?.first_name;
  const lastName = data?.[0]?.last_name;
  const username =
    firstName && lastName ? `${firstName} ${lastName}` : undefined;
  return (
    <Flex h="100%" px="md" align="center">
      <Burger
        opened={mobileOpened}
        onClick={toggleMobile}
        hiddenFrom="sm"
        size="sm"
      />
      <Image
        radius="md"
        w={`calc(200px - ${em(32)})`}
        ml="sm"
        fit="contain"
        padding="md"
        src={Logo}
      />
      <Box ml="auto">
        <Flex gap="md" direction="row" align="center">
          <Menu shadow="md" width={200}>
            <Menu.Target>
              <Group style={{ cursor: 'pointer' }}>
                {' '}
                {user.isSuccess && (
                  <Text fw={500} size="sm" visibleFrom="sm">
                    {username ? username : user?.data[0]?.username}
                  </Text>
                )}
                <Avatar
                  alt={getUsername()}
                  email={user?.data?.username}
                  round="25px"
                  size="md"
                >
                  {getUsername().match(regexPattern)[1].toUpperCase()}
                  {getUsername().match(regexPattern)[2].toUpperCase()}
                </Avatar>
              </Group>
            </Menu.Target>

            <Menu.Dropdown>
              <Menu.Label>Profile</Menu.Label>
              <Menu.Item
                leftSection={
                  <IconSettings style={{ width: rem(14), height: rem(14) }} />
                }
                onClick={() => setIsModalOpen(true)}
              >
                User Settings
              </Menu.Item>
              <Menu.Item
                c="red"
                leftSection={
                  <IconLogout2 style={{ width: rem(14), height: rem(14) }} />
                }
                onClick={handleSignOut}
              >
                Sign Out
              </Menu.Item>
            </Menu.Dropdown>
          </Menu>
          <Modal
            opened={isModalOpen}
            onClose={() => {
              setIsModalOpen(false);
              updateSettings();
            }}
            size="auto"
            withCloseButton={false}
          >
            <Group
              style={{ justifyContent: 'space-between', alignItems: 'center' }}
              mb="md"
            >
              <Text fw={700}>Settings </Text>
              <Group>
                <Button
                  onClick={() => {
                    updateSettings();
                    setIsModalOpen(false);
                  }}
                >
                  <IconCheck />
                </Button>
              </Group>
            </Group>
            <Group
              style={{ justifyContent: 'space-between', alignItems: 'center' }}
            >
              <Text>Analysis Notifications: </Text>

              <Select
                data={analysisNotifications}
                defaultValue={'All insights'}
                value={value}
                onChange={setValue}
                allowDeselect={false}
              />
            </Group>
          </Modal>
        </Flex>
      </Box>
    </Flex>
  );
};

export default Header;
